import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core/styles";

const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    bottoms: {
        // position: "fixed",
        // bottom: theme.spacing(2),
        // left: '50%',
        // transform: 'translate(-50%, 0)',
    }
}));

function Footer() {
    const classes = useStyles();

    return (
        <div className={classes.bottoms}>
            {!inIFrame && (
                <Box mt={5}>
                    <Typography variant="body2" color="textSecondary" align="center">
                        {'Copyright © '}
                        <Link color="inherit" href="https://JunctionBox.io/">
                            JunctionBox.io
                        </Link>{' '}
                        {new Date().getFullYear()}
                        {'.'}
                    </Typography>
                </Box>
            )}
        </div>
    )
}

export default Footer;
